/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useContext, useState } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import Button from './Button';
import Arrow from './Arrow';
import { genDirections } from '../utils/genDirections';
import LocationContext from './Context';

interface StockistCardProps {
    stockist: any;
    distance?: number;
}

// TODO will be own component
interface StyledAsideItemProps {
    isActive: boolean;
}

const StyledAsideListItem = styled.li`
    list-style: none;
    padding: 12px 0 0 0;
    margin: 0;
`;

const StyledAsideItem = styled.div<StyledAsideItemProps>`
    ${({ isActive, theme }) => css`
        display: grid;
        grid-template-areas: 'content' 'extra' 'footer';
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto;
        grid-auto-rows: auto;
        grid-row-gap: 8px;
        padding: 16px;
        border: 2px solid #fff;
        background-color: #fff;
 border-radius: 3px;
        margin: 0;
        font-size: 16px;
        line-height: 18px;
        transition all 0.2s ease-in;
        color: #222;

    

        .miles {
            grid-area: content;
            font-size: 12px;
            text-align: right;
        }
        .action {
            grid-area: footer;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
           // height: 40px;
           > * {
               max-height: 26px;
           }

        }

      

        ${
            isActive &&
            css`
                border-color: ${theme.colors.alt};
            `
        }
    `}
`;

const StyledIntro = styled.span`
    display: flex;
    flex-direction: column;
    grid-area: content;

    .tag {
        font-size: 12px;
        text-transform: uppercase;
    }

    > * + * {
        margin-top: 6px;
        display: block;
    }
`;
const StyledAddress = styled.address`
    display: flex;
    flex-direction: column;
    grid-area: extra;
    font-style: normal;
    line-height: 18px;
    font-size: 14px;

    a {
        font-weight: bold;
        text-decoration: none;
        margin-top: 12px;

        &:hover {
            text-decoration: underline;
        }
    }
`;
const StyledAddressRow = styled.span``;

const StockistCard: FC<StockistCardProps> = ({ stockist, distance }) => {
    const [showExtra, setShowExtra] = useState(false);
    const { selectedLatLng } = useContext(LocationContext);
    const { id, title, stockistMeta } = stockist;

    const addressRow = (item) => (item ? <StyledAddressRow>{item}</StyledAddressRow> : null);
    const telRow = (item) =>
        item ? (
            <StyledAddressRow>
                <a href={`tel:${item.replace(/\s/g, '')}`}>{item}</a>
            </StyledAddressRow>
        ) : null;

    const handleDirections = (destination, detail) => {
        const url = genDirections(selectedLatLng, destination);

        window?.dataLayer?.push({
            event: 'gtmClick',
            element: {
                category: 'find a stockist',
                name: 'get stockist directions', // set as constant even if the element text changes
                text: 'Get directions', // click text of the element clicked
                detail, // name of the stockist
            },
        });

        if (url) {
            window.open(url, '_blank');
        }
    };

    const handleToggleDetails = (detail) => {
        window?.dataLayer?.push({
            event: 'gtmClick',
            element: {
                category: 'find a stockist',
                name: 'show stockist details', // set as constant even if the element text changes
                text: `${showExtra ? 'hide' : 'show'} details`, // click text of the element clicked
                detail, // name of the stockist
            },
        });

        setShowExtra((s) => !s);
    };
    return (
        <>
            <StyledAsideListItem>
                <StyledAsideItem isActive>
                    <StyledIntro>
                        <span className="tag">
                            {stockistMeta?.stockistType === 'GARDEN_CENTRE' ? 'GARDEN CENTRE' : 'OTHER RETAILER'}
                        </span>
                        <strong>{title}</strong>
                        {!showExtra && (
                            <span>
                                {stockistMeta.stockistTown} {stockistMeta.stockistPostcode}
                            </span>
                        )}
                    </StyledIntro>
                    <span className="miles">{distance} MILES</span>
                    {showExtra && (
                        <StyledAddress>
                            {addressRow(stockistMeta.stockistAddress)}
                            {addressRow(stockistMeta.stockistAddress2)}
                            {addressRow(stockistMeta.stockistAddress3)}
                            {addressRow(stockistMeta.stockistTown)}
                            {addressRow(stockistMeta.stockistCounty)}
                            {addressRow(stockistMeta.stockistPostcode)}
                            {telRow(stockistMeta.stockistTelephoneNumber)}
                        </StyledAddress>
                    )}

                    <div className="action">
                        <Button
                            color="link"
                            size="small"
                            label="Details"
                            icon={<Arrow direction={showExtra ? 'up' : 'down'} />}
                            onClick={() => handleToggleDetails(title)}
                        />
                        {selectedLatLng?.lat && (
                            <Button
                                color="link"
                                size="small"
                                label="Directions"
                                icon={<Arrow direction="right" />}
                                onClick={() =>
                                    handleDirections(
                                        {
                                            lat: stockistMeta.stockistLocation.latitude,
                                            lng: stockistMeta.stockistLocation.longitude,
                                        },
                                        title
                                    )
                                }
                            />
                        )}
                    </div>
                </StyledAsideItem>
            </StyledAsideListItem>
        </>
    );
};

export default StockistCard;
